exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".previousStatus-3ed15{display:flex;align-items:center}", ""]);

// Exports
exports.locals = {
	"previousStatus": "previousStatus-3ed15"
};